"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCountries = void 0;
const constants_1 = require("../constants");
const SUPPORTED_COUNTRIES_MAP = __importStar(require("../constants/generated/supported-countries.json"));
/*
  The "stage" attribute of the markets/{brand}-{country}.json config is
  meant to be read as the highest environment a market is supported.
  This means that if BK-DE has its "stage" attribute set to "prod", that
  means the market is supported UP TO PROD ("dev", "staging", "qa", "prod").

  This util gets the lowest stage from a list of stages, and returns a list
  of the lowest stage and every stage higher than itself. E.g. it maps
  - ['dev']             => ['dev', 'staging', 'qa', 'prod']
  - ['prod']            => ['prod']
  - ['prod', 'staging'] => ['staging', 'qa', 'prod']
  - ['none', 'qa']      => ['none', 'dev', 'staging', 'qa', 'prod']
*/
const getLowestStageAndHigher = (stages) => {
    if (stages.length === 0) {
        return [];
    }
    const lowestStage = stages.sort((a, b) => {
        return constants_1.ALL_STAGES.indexOf(a) - constants_1.ALL_STAGES.indexOf(b);
    })[0];
    return constants_1.ALL_STAGES.slice(constants_1.ALL_STAGES.indexOf(lowestStage));
};
const getSupportedCountries = (options) => {
    var _a, _b, _c, _d, _e;
    const brands = ((_a = options === null || options === void 0 ? void 0 : options.brands) !== null && _a !== void 0 ? _a : constants_1.ALL_BRANDS).map((x) => x.toLowerCase());
    const awsRegions = ((_b = options === null || options === void 0 ? void 0 : options.awsRegions) !== null && _b !== void 0 ? _b : constants_1.ALL_AWS_REGIONS).map((x) => x.toLowerCase());
    const stages = (options === null || options === void 0 ? void 0 : options.stages)
        ? getLowestStageAndHigher(options.stages.map((x) => x.toLowerCase()))
        : constants_1.ALL_STAGES;
    let supportedRegions = [];
    for (const brand of brands) {
        for (const awsRegion of awsRegions) {
            for (const stage of stages) {
                supportedRegions = [
                    ...supportedRegions,
                    ...((_e = (_d = (_c = SUPPORTED_COUNTRIES_MAP[brand]) === null || _c === void 0 ? void 0 : _c[awsRegion]) === null || _d === void 0 ? void 0 : _d[stage]) !== null && _e !== void 0 ? _e : []),
                ];
            }
        }
    }
    return supportedRegions;
};
exports.getSupportedCountries = getSupportedCountries;
